import React from "react";

export const ProductVideoView = ({ videoDescs, media_types, content_types }) => {
  return (
    <div>
      <div className="pb-3">
        <i className="fab fa-youtube" /> Product Video
      </div>
      
      {videoDescs?.length === 0 && (
        <div className="my-5 text-center">
          <p className="text-muted">No video available</p>
        </div>
      )}

      <div className="row">
        {videoDescs?.map((video, index) => {
          return (
            <div className="col-md-4 mb-3" key={index}>
              <div className="d-flex align-items-center">
                <div style={{ width: "50%", height: 200 }}>
                  <iframe
                    width="100%"
                    height="200"
                    src={video?.filePath?.replace("YOUTUBE_VIDEO_ID", video.fileName) || ""}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  />
                </div>
                <div className="mx-3">
                  <div>
                    <div className="text-secondary">Description</div>
                    <p>{video?.media_desc || "-"}</p>
                  </div>
                  <div>
                    <div className="text-secondary">Language</div>
                    <p>{video?.language_name || "-"}</p>
                  </div>
                  <div className="mb-3">
                    <div className="text-secondary">Image Types</div>
                    {video?.media_types?.map((item) => {
                      const mediaType = media_types.find((type) => type.code === item);
                      return (
                        <div key={item} className="badge badge-warning mr-1">
                          {mediaType ? mediaType.name : item}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    <div className="text-secondary">Content Types</div>
                    {video?.content_types?.map((item) => {
                      const contentType = content_types.find((type) => type.code === item);
                      return (
                        <div key={item} className="badge badge-warning mr-1">
                          {contentType ? contentType.name : item}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
